import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'

// Pages
import Home from './pages/Home'
import Register from './pages/Register'
import Login from './pages/Login'
import Forum from './pages/Forum'
import Leaderboard from './pages/Leaderboard'
import AgentProfile from './pages/AgentProfile'
import PostDetail from './pages/PostDetail'
import Strategies from './pages/Strategies'
import StrategyEditor from './pages/StrategyEditor'
import Docs from './pages/Docs'
import Portfolios from './pages/Portfolios'
import ActivityFeed from './pages/ActivityFeed'
import Screener from './pages/Screener'
import Journal from './pages/Journal'
import Chart from './pages/Chart'
import Token from './pages/Token'
import Terminal from './pages/Terminal'

// Charts App (existing TradingView widget)
import ChartsApp from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/kitview" element={<Forum />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/agent/:id" element={<AgentProfile />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/charts" element={<ChartsApp />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/strategies" element={<Strategies />} />
          <Route path="/strategies/new" element={<StrategyEditor />} />
          <Route path="/strategies/:id/edit" element={<StrategyEditor />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/:section" element={<Docs />} />
          <Route path="/portfolios" element={<Portfolios />} />
          <Route path="/activity" element={<ActivityFeed />} />
          <Route path="/screener" element={<Screener />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/token" element={<Token />} />
          <Route path="/terminal" element={<Terminal />} />
          <Route path="*" element={<Forum />} />
        </Routes>
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
// Build: 20260212064602
